import ScrollReveal from "../motion/ScrollReveal";
import StaggerContainer from "../motion/StaggerContainer";
import TiltCard from "../motion/TiltCard";

const testimonials = [
  {
    quote: "Before OWL, we were losing leads we'd already paid to generate. Their AI system now contacts every lead within 60 seconds — even at 11pm.",
    name: "R.M.",
    title: "Managing Partner",
    company: "Real Estate Agency, Mumbai",
    initials: "RM",
  },
  {
    quote: "They built our CRM exactly the way our firm works — not the other way around. We went from spreadsheets to a system our whole team actually uses.",
    name: "P.K.",
    title: "Senior Advocate",
    company: "Mumbai High Court",
    initials: "PK",
  },
  {
    quote: "The ERP replaced three separate tools we were paying for. Everything — inventory, billing, HR — now in one place. Paid for itself in 4 months.",
    name: "A.S.",
    title: "Director",
    company: "Manufacturing MSME, Pune",
    initials: "AS",
  },
];

export default function Testimonials() {
  return (
    <>
      <section
        className="owl-testimonials-section"
        style={{
          background: "#0E0E0E",
          padding: "120px 40px",
          borderTop: "0.5px solid rgba(212,168,67,0.12)",
        }}
      >
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <ScrollReveal direction="up" delay={0}>
            <div style={{ marginBottom: 60 }}>
              <div
                style={{
                  fontFamily: "'Playfair Display', serif",
                  fontWeight: 300,
                  fontSize: "clamp(36px, 4.5vw, 56px)",
                  color: "#F8F4EC",
                  lineHeight: 0.9,
                }}
              >
                The proof
              </div>
              <div
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: "clamp(36px, 4.5vw, 56px)",
                  color: "#D4A843",
                  lineHeight: 0.95,
                }}
              >
                is in results.
              </div>
            </div>
          </ScrollReveal>

          <StaggerContainer stagger={0.12} className="owl-testimonials-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 24 }}>
            {testimonials.map((testimonial) => (
              <TiltCard
                key={testimonial.initials}
                className="card-tilt-hover"
                style={{
                  background: "#111010",
                  border: "1px solid rgba(212,168,67,0.18)",
                  borderRadius: 3,
                  padding: 40,
                  position: "relative",
                }}
              >
                {/* Animated quote mark SVG */}
                <svg
                  width="48" height="40" viewBox="0 0 48 40"
                  style={{ marginBottom: 16, opacity: 0.3 }}
                >
                  <path
                    d="M0 24C0 14 6 4 18 0L20 4C10 8 8 14 8 20H18V40H0V24ZM26 24C26 14 32 4 44 0L46 4C36 8 34 14 34 20H44V40H26V24Z"
                    fill="#D4A843"
                    strokeDasharray="200"
                    strokeDashoffset="200"
                    style={{ animation: "svgDraw 2s ease-out forwards" }}
                  />
                </svg>

                <p
                  style={{
                    fontFamily: "'Playfair Display', serif",
                    fontWeight: 300,
                    fontStyle: "italic",
                    fontSize: 17,
                    color: "#F8F4EC",
                    lineHeight: 1.7,
                    marginBottom: 32,
                  }}
                >
                  {testimonial.quote}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      background: "rgba(212,168,67,0.15)",
                      border: "1px solid rgba(212,168,67,0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontFamily: "'Bebas Neue', sans-serif",
                      fontSize: 14,
                      letterSpacing: "0.1em",
                      color: "#D4A843",
                      flexShrink: 0,
                    }}
                  >
                    {testimonial.initials}
                  </div>
                  <div>
                    <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500, fontSize: 16, color: "#F8F4EC" }}>{testimonial.name}</div>
                    <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300, fontSize: 13, color: "#8B8378" }}>
                      {testimonial.title} · {testimonial.company}
                    </div>
                  </div>
                </div>
              </TiltCard>
            ))}
          </StaggerContainer>
        </div>
      </section>

      <style>{`
        @media (max-width: 960px) {
          .owl-testimonials-grid {
            grid-template-columns: 1fr !important;
          }
        }

        @media (max-width: 640px) {
          .owl-testimonials-section {
            padding: 64px clamp(20px, 5vw, 32px) !important;
          }
        }
      `}</style>
    </>
  );
}
